import { BaseDto } from '@greco/util-dto';

export class CreateAgreementUsageDto extends BaseDto {
  agreementId: string;
  type: string;
  url: string;
  label: string;
  created: Date;
}
